import { render, staticRenderFns } from "./ProductReportsScoreChart.vue?vue&type=template&id=48c331fc&scoped=true"
import script from "./ProductReportsScoreChart.vue?vue&type=script&lang=js"
export * from "./ProductReportsScoreChart.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsScoreChart.vue?vue&type=style&index=0&id=48c331fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c331fc",
  null
  
)

export default component.exports